import { useTranslation } from 'react-i18next';
import {
  CustomersOrdersResponseDto,
  OrderResponseDto,
} from '@tiendanube/common';
import {
  Domain as DomainEnum,
  Status as StatusEnum,
} from '@tiendanube/common/src/enums';
import { Label, Stack, Text } from '@tiendanube/components';
import { PAYMENT_STATUS_EXPIRED_ENABLED } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useResponsive } from 'commons/components';
import { payment, order as orderStatus } from '../status';

interface ColumnPaymentStatusProps {
  order: OrderResponseDto | CustomersOrdersResponseDto;
}

function ColumnPaymentStatus({ order }: ColumnPaymentStatusProps): JSX.Element {
  const { t } = useTranslation([DomainEnum.ORDERS]);
  const { isDesktop } = useResponsive();
  const [hasExpiredTag] = useHasTags([PAYMENT_STATUS_EXPIRED_ENABLED]);

  // If user doesn't have the expired tag, show EXPIRED as VOIDED
  const paymentStatus =
    order.payment.status === StatusEnum.EXPIRED && !hasExpiredTag
      ? StatusEnum.VOIDED
      : (order.payment.status as StatusEnum);

  const { icon, status, appearance } =
    order.status !== StatusEnum.OPEN
      ? orderStatus(order.status as StatusEnum)
      : payment(paymentStatus);

  let label = t(`status.${status}`);

  if (status === StatusEnum.CANCELLED) {
    label = t('status.list.cancelled');
    if ((order as OrderResponseDto).cancelReason === 'automatic') {
      label = t('status.list.automaticCancelled');
    }
  }

  return (
    <Stack column spacing="tight" align="flex-start">
      <Label id={status} label={label} icon={icon} appearance={appearance} />
      {isDesktop && !!order.payment.gateway && (
        <Text block size="caption" trimText trimLines={1}>
          {`${t(`gateway.${order.payment.gateway}`, order.payment.gateway)}`}
        </Text>
      )}
    </Stack>
  );
}

export default ColumnPaymentStatus;
